import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { ROUTES } from 'shared/constants/routes';

const Layout = ({ component: Component, ...rest }) => {
  const auth = useSelector((state) => state?.auth);
  return (
    <Route
      exact
      {...rest}
      render={(routeProps) =>
        auth.authenticated ? (
          <Fragment>
            <Header />
            <Component {...routeProps} />
            <Footer />
          </Fragment>
        ) : (
          <Redirect to={ROUTES.HOME.LINK} />
        )
      }
    />
  );
};

export default Layout;
